// export const ENDPOINT = "http://216.219.84.38:8787/api/";
// export const WEB_URL = "http://216.219.84.38:6464/";

export const ENDPOINT = "https://api-res.eskaiy.dev/api/";
export const WEB_URL = "https://res.eskaiy.dev/";
